// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__footer___1NlzQ"};